//Set up data layer object before initialising cookie consent outside of GTM
  window.dataLayer = window.dataLayer || [];
  (function (a) { "undefined" === typeof window[a] && (window[a] = function (b) { window[a].config = b }) })("user_consent");

  user_consent({
    consent_groups: {
      functional: {
        name: "Functional Cookies",
        description: "First party cookies designed to add personalisation to your indiviual experience on the website, remembering preferences and improving navigation through the website.",
        default: "granted"
      },
      analytics: {
        name: "Analytics Cookies",
        description: "These cookies help us understand how you interact with the site. We use this data to identify areas to improve.",
        default: "granted",
      },
      marketing: {
        name: "Marketing Cookies",
        default: "granted",
        description: "These cookies are used by us and our partners, including Shopify, to optimize marketing communications and show you ads on other websites.",
      },
      personalisation: {
        name: "Ad personalisation",
        default: "granted",
        description: "Allow Google marketing products, such as Google Ads, to create personalised adverts and remarket to you when browsing the web. This will allow us to provide you with relevant advertisements based on our products that you might be interested in."
      }
    },
    cookie: {
      name: "UserConsent",
      timeout: 31449600000,
      host: document.location.hostname.replace(/^www\./, "")
    },
    linker: {
      domains: [],
      parameter: "cc"
    },
    dispatch: {
      gtm: window.dataLayer,
      gtm_event: false,
      event: "user_consent_updated"
    },
    buttons: {
      close: {
        enabled: false,
        state: "reject"
      },
      background: {
        enabled: false,
        state: "reject"
      },
      reject_main: {
        enabled: false,
      },
      reject_secondary: {
        enabled: true,
      }
    },
    background: "fade",
    debug:false
  });